export const RESOURCE_ASSETS_USER_PERMISSION = 'RESOURCE_ASSETS_USER_PERMISSION';
export const ASSETS_USER_PERMISSION_KEY = 'ASSETS_USER_PERMISSION';

export const ASSETS_USER_PERMISSION_MAX_AGE = 5 * 60 * 1000; // 15 minutes

export const emptyAssetsPermissionResponse = {
	isAssetsAdmin: false,
	isLicensedAssetsUser: false,
};
